
import { useSelector } from "react-redux"
import styled from "styled-components"
import { getAdminUyeSuruculeri } from "../../features/admin2/admin2Slice"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import UyeSuruculerContainer from "../shared/adminUyelerAraclar/MobilUyeSuruculerContainer"

const Container = styled.div`
    width: 100%;

    .content{
            width: 100% !important;
            display: flex;
            flex-direction: column;
            align-items: center;
            max-height: 600px;
            overflow: auto;
            gap: 0 !important;

            .titles{
                width: 100%;
                padding: 0 10px;
                gap: 15px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                display: flex;

                .title-item{
                    flex: 1;
                    text-align: center;
                }
            }
        }
`

const titles = [
    "Adı Soyadı",
    "Cep Telefonu",
    "TC No",
    "Doğum Tarihi",
    "Adres",
    "Adres İl/ilçe",
    "Ehliyet",
    "SRC",
    "Belgeler",
    "İşlem"
]


const KooperatifUyeSuruculer = () => {

    const {uyeItemData, uyeSurucuList} = useSelector(state => state.uyelerAraclar)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getAdminUyeSuruculeri({userId: uyeItemData.id}))
    },[])

  return (
    <Container>
        <div className="content">

        <div className="titles">
            {
                titles.map((item) => (
                    <div className="title-item">{item}</div>
                ))
            }
        </div>
        {
            uyeSurucuList?.map(item => (
                <UyeSuruculerContainer data={item} uyeItemData={uyeItemData}/>
            ))
        }
        </div>
    </Container>
  )
}

export default KooperatifUyeSuruculer